/** @jsx jsx */
import { Box, jsx } from 'theme-ui'
import { Link } from 'gatsby'

const Footer = () => {
  return (
    <footer
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        padding: '14px 0',
        backgroundColor: '#333333',
        width: '100vw',
        marginLeft: 'calc(50% - 50vw)',
        marginRight: 'calc(50% - 50vw)',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Link
          to="/terms/"
          sx={{ color: '#ffffff', fontSize: '0.9rem', textDecoration: 'none' }}
        >
          利用規約
        </Link>
        <span sx={{ color: '#ffffff' }}>|</span>
        <Link
          to="/privacy/"
          sx={{ color: '#ffffff', fontSize: '0.9rem', textDecoration: 'none' }}
        >
          個人情報の取扱いについて
        </Link>
      </Box>
      <p sx={{ color: '#bfbfbf', fontSize: '0.65rem', marginTop: '8px' }}>
        Copyright (C) {new Date().getFullYear()} UKMETA All Rights Reserved.
      </p>
    </footer>
  )
}

export default Footer
